import script from "./profile-page.vue?vue&type=script&setup=true&lang=js"
export * from "./profile-page.vue?vue&type=script&setup=true&lang=js"

import "./profile-page.vue?vue&type=style&index=0&id=4301d21e&lang=scss"

const __exports__ = script;

export default __exports__